<section class="n-flex n-flex-column n-align-center n-justify-center">
  Page Not Found
</section>
